<template>

    <div>
      <form class="myForm mt-5" @submit.prevent="submitForm">
          <div class="form-group row">
            <label for="nome" class="col-sm-2 col-form-label">Fornecedor:<span class='text-danger'> *</span></label>
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="fornecedor" required>
            </div>
          </div>
           <div class="form-group row">
            <label for="nome" class="col-sm-2 col-form-label">Tipo de fornecimento:<span class='text-danger'> *</span></label>

            <div class="col-sm-6">
              <multiselect v-model="value" tag-placeholder="Selecione" select-label="" deselect-label="X" selectedLabel="" placeholder="Selecione ao menos um tipo de fornecimento" label="name" track-by="code" :options="options" :multiple="true" @tag="addTag"><span slot="noResult" class="text-info">Nenhum tipo de fornecimento encontrado</span></multiselect>
            </div>
          </div>
      </form>
      <div class="container text-right mt-2">
        <button class="btn btn-sm btn-danger" @click="retorno">Cancelar</button>
        <button class="btn btn-sm btn-success ml-2" :disabled="(value == '' || !fornecedor != '')" @click="salvar">Salvar</button>
      </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect'

export default {
  name: 'FornecedoresCadastro',
  data () {
    return {
      fornecedor: '',
      tpFornecedores: [],
      value: [],
      options: []
    }

  },
  components: {
     Multiselect
  },
  methods: {
      retorno() {
        this.$router.go(0)
      },
      salvar(){

          let tipoFo = this.value
          let tipoForne = []

          for(var i = 0; i < tipoFo.length; i++){
            tipoForne.push(tipoFo[i].code);
          }

          api.enviarRequisicao('post', '/api/contas-consumo/fornecedores', {
              ba00_fornecedor: this.fornecedor,
              tipoFornecimentos: tipoForne
          }).then(response => {
          this.$swal('Atenção!','Dados salvos com sucesso.','success')
           .then(
              function () {
                  history.go(0)
              }
          );
        })
        .catch(function (error) {
          this.$swal('Atenção!','Erro ao cadastrar os dados.','error')
        })
      },
      addTag (newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
        }
        this.options.push(tag)
        this.value.push(tag)
      }

  },
  mounted: function(){

    api.enviarRequisicao('get', '/api/contas-consumo/tipo-fornecimentos')
      .then(response => {
        for(var i = 0;i < response.data.length;i++){
          this.tpFornecedores.push({name : response.data[i].tp01_descricao, code: response.data[i].tp01_id})
        }
        this.options = this.tpFornecedores
      })

  }
}
</script>

 <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>


a {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}



</style>
